module.exports = __webpack_public_path__ + "static/media/gender.380160d6.svg";